// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from '../../utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const BASE_URL = process.env.REACT_APP_BASE_API_URL;
const PATH = 'qrcodes';
const navigateTo = '/qrcodes';

const initialState = {
    qrcodes: [],
    error: null,
    totalPages: 1,
    loading: false,
    limit: 10,
    currentPage: 1
};

// Reducer
const slice = createSlice({
    name: 'qrcodes',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },

        startLoading(state, action) {
            state.loading = true;
        },
        stopLoading(state, action) {
            state.loading = false;
        },

        // GET USERS STYLE 1
        getSuccess(state, action) {
            state.qrcodes = action.payload;
            const total = action?.payload?.length || 0;
            let pages = Math.floor(total / state.limit);
            const remainder = total % state.limit;
            if (remainder !== 0) {
                pages += 1;
            }
            state.totalPages = pages;
            state.loading = false;
        },
        addSuccess(state, action) {
            state.loading = false;
        },
        editSuccess(state, action) {
            state.loading = false;
        },
        deleteSuccess(state, action) {
            state.loading = false;
            state.qrcodes = state.qrcodes.filter((item) => item.id !== action.payload.id);
        },
        setCurrentPage(state, action) {
            console.log(action.payload);
            state.currentPage = action.payload;
        }
    }
});

export default slice.reducer;

// Actions

export function startLoading() {
    return async () => {
        dispatch(slice.actions.startLoading());
    };
}

export function stopLoading() {
    return async () => {
        dispatch(slice.actions.stopLoading());
    };
}

export function getQRCodes() {
    return async () => {
        try {
            const result = await axios.get(`${BASE_URL}/${PATH}`);
            console.log('RES [getQRCodes]:', result.data.data);
            dispatch(slice.actions.getSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [getQRCodes]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getQRCodesByEqId(id = '') {
    return async () => {
        try {
            const result = await axios.get(`/exercises/equipments/${id}`, );
            console.log('RES [getQRCodesByEqId]:', result.data.data);
            dispatch(slice.actions.getSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [getQRCodesByEqId]:', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addQRCode(data) {
    return async () => {
        try {
            const result = await axios.post(`${BASE_URL}/${PATH}`, data);
            console.log('RES [addQRCode] ======> ', result.data.data);
            dispatch(slice.actions.addSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [addQRCode] =======> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function editQRCode(id, data) {
    return async () => {
        try {
            const result = await axios.put(`${BASE_URL}/${PATH}?id=${id}`, data);
            console.log('RES [editQRCode] =======> ', result?.data?.data);
        } catch (error) {
            console.log('ERR [editQRCode] ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function deleteQRCode(id = '') {
    return async () => {
        try {
            const result = await axios.delete(`${BASE_URL}/${PATH}?id=${id}`);
            console.log('RES [deleteQRCode] =======> ', result);
            // dispatch(slice.actions.deleteSuccess(result.data.data));
        } catch (error) {
            console.log('ERR [deleteQRCode] =========> ', error);
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setCurrentPage(page) {
    return async () => {
        dispatch(slice.actions.setCurrentPage(page));
    };
}
